export default "__VITE_ASSET__FwEwB3E1__ 150w, __VITE_ASSET__DOvqeKfV__ 300w, __VITE_ASSET__BzAP2ier__ 600w, __VITE_ASSET__BvkFydTt__ 793w";